module.exports = __webpack_public_path__ + "static/media/best-bike-advice-logo.08c414b1.webp";